function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "weather-windy");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Sense-Mobile-#1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "panel-aktywny",
  transform: "translate(-294.000000, -431.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4",
  transform: "translate(16.000000, 417.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "weather-windy",
  transform: "translate(278.000000, 14.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3,10 C2.44771525,10 2,9.55228475 2,9 C2,8.44771525 2.44771525,8 3,8 L11,8 C12.1045695,8 13,7.1045695 13,6 C13,4.8954305 12.1045695,4 11,4 C10.45,4 9.95,4.22 9.59,4.59 C9.2,5 8.56,5 8.17,4.59 C7.78,4.2 7.78,3.56 8.17,3.17 C8.9,2.45 9.9,2 11,2 C13.209139,2 15,3.790861 15,6 C15,8.209139 13.209139,10 11,10 L3,10 M18,12 C18.5522847,12 19,11.5522847 19,11 C19,10.4477153 18.5522847,10 18,10 C17.72,10 17.47,10.11 17.29,10.29 C16.9,10.68 16.27,10.68 15.88,10.29 C15.5,9.9 15.5,9.27 15.88,8.88 C16.42,8.34 17.17,8 18,8 C19.6568542,8 21,9.34314575 21,11 C21,12.6568542 19.6568542,14 18,14 L4,14 C3.44771525,14 3,13.5522847 3,13 C3,12.4477153 3.44771525,12 4,12 L18,12 M17,18 L3,18 C2.44771525,18 2,17.5522847 2,17 C2,16.4477153 2.44771525,16 3,16 L17,16 C18.6568542,16 20,17.3431458 20,19 C20,20.6568542 18.6568542,22 17,22 C16.17,22 15.42,21.66 14.88,21.12 C14.5,20.73 14.5,20.1 14.88,19.71 C15.27,19.32 15.9,19.32 16.29,19.71 C16.47,19.89 16.72,20 17,20 C17.5522847,20 18,19.5522847 18,19 C18,18.4477153 17.5522847,18 17,18 Z",
  id: "Shape",
  fill: "#00346A",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 24,
  height: 24
})))));

var SvgWeatherWindy = function SvgWeatherWindy(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWeatherWindy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/weather-windy.c03210c3.svg";
export { ForwardRef as ReactComponent };